import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';

import Title from '../../DashboardScreen/part/Title';
import TableLine from './TabLine';
import { MoulinetteLog } from '../../../models/moulinetteLog';

export default function TabLogs(props: { datas: MoulinetteLog[] | null }) {
	const [currentPage, setCurrentPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [firstIndex, setfirstIndex] = useState(0);
	const [lastIndex, setLastIndex] = useState(rowsPerPage || 0);
	const [allDatas] = useState<MoulinetteLog[] | null>(props.datas);

	const currentItems: MoulinetteLog[] = allDatas ? allDatas.slice(firstIndex, lastIndex) : [];

	const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
		if (allDatas) {
			const lastIndex = (newPage + 1) * rowsPerPage < allDatas.length ? (newPage + 1) * rowsPerPage : allDatas.length;
			setLastIndex(lastIndex);
			setfirstIndex(newPage * rowsPerPage);
		}
		setCurrentPage(newPage);
	};

	const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const rows = parseInt(event.target.value, 10);

		setLastIndex(rows);
		setRowsPerPage(rows);
		setfirstIndex(0);
		setCurrentPage(0);
	};

	return (
		<React.Fragment>
			<Title>Erreurs d'indexations taureaux</Title>
			<Table size="small">
				<TableHead>
					<TableRow sx={{ textAlign: 'center' }}>
						<TableCell>Date</TableCell>
						<TableCell>Nom</TableCell>
						<TableCell>Nb. Erreurs</TableCell>
						<TableCell>Liste taureaux</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>{currentItems && currentItems.map((row: MoulinetteLog, index: number) => <TableLine row={row} key={index} />)}</TableBody>
			</Table>
			{allDatas && <TablePagination component="div" count={allDatas.length} page={currentPage} onPageChange={handleChangePage} rowsPerPage={rowsPerPage} onRowsPerPageChange={handleChangeRowsPerPage} />}
		</React.Fragment>
	);
}
